<script>
import HighlightsElements from '@/mixins/HighlightsElements'
import SharedPageHeader from '@/components/customers/edit/SharedPageHeader.vue'
import ImpersonatePanel from '@/components/customers/edit/customer-portal/ImpersonatePanel.vue'

export default {
  components: {
    'mia-impersonate-panel': ImpersonatePanel,
    'mia-shared-page-header': SharedPageHeader
  },

  mixins: [HighlightsElements]
}
</script>

<template>
  <div>
    <mia-shared-page-header />

    <div class="my-16 space-y-16">
      <mia-is-allowed to="customer_portal_impersonation">
        <mia-impersonate-panel />
      </mia-is-allowed>
    </div>
  </div>
</template>
